import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "46",
  height: "46",
  viewBox: "0 0 46 46",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M22.9277 35.2773C22.9174 35.2773 22.9072 35.2773 22.9072 35.2773L5.08989 34.8377C4.67078 34.8275 4.313 34.5719 4.15967 34.1835C4.01656 33.7951 4.10856 33.3555 4.41523 33.0693L17.2441 21.0071L17.285 20.9662L18.205 20.1995C18.3174 20.1075 18.4503 20.0359 18.5934 19.9951L37.9543 14.7613C38.3837 14.6488 38.8437 14.8226 39.0788 15.1906C39.3241 15.5688 39.2934 16.0493 39.0072 16.3968L23.7148 34.9093C23.5206 35.1444 23.2343 35.2773 22.9277 35.2773ZM7.625 32.8546L22.4574 33.2226L35.3886 17.5724L19.3397 21.9066L18.6139 22.5097L7.625 32.8546Z",
      fill: "#FF212A"
    }, null, -1),
    _createElementVNode("path", {
      d: "M15.7891 16.9095L17.719 16.2349L23.9023 33.9229L21.9724 34.5976L15.7891 16.9095Z",
      fill: "#FF212A"
    }, null, -1),
    _createElementVNode("path", {
      d: "M37.0703 12.1499L38.9487 11.3428L41.8343 18.0582L39.9559 18.8653L37.0703 12.1499Z",
      fill: "#FF212A"
    }, null, -1)
  ])))
}
export default { render: render }